export default __webpack_public_path__ + "static/media/aboutimg.f9cbaa04.png";